// eslint-disable react/no-array-index-key
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/login" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app/',
        component: () => <Redirect to="/app/management/users" />
      },
      {
        exact: true,
        path: '/app/account',
        component: () => <Redirect to="/app/management/users" />
      },
      {
        exact: true,
        path: '/app/management/users',
        component: lazy(() =>
          import('src/views/management/Users/UserListView')
        )
      },
      {
        exact: true,
        path: '/app/management/users/create-user',
        component: lazy(() =>
          import('src/views/management/Users/UserCreateForm')
        )
      },
      {
        exact: true,
        path: '/app/management/merchants',
        component: lazy(() => import('src/views/management/Merchants/MerchantListView'))
      },
      {
        exact: true,
        path: '/app/management/upload',
        component: lazy(() =>
          import('src/views/management/UploadFile')
        )
      },
      {
        exact: true,
        path: '/app/management/reports',
        component: lazy(() =>
          import('src/views/management/Reports')
        )
      },
      {
        exact: true,
        path: '/app/management/complaints',
        component: lazy(() =>
          import('src/views/management/Requests')
        )
      },
      {
        exact: true,
        path: '/app/management/chats',
        component: lazy(() =>
          import('src/views/management/Chats/ChatListView')
        )
      },
      {
        exact: true,
        path: '/app/management/chats/:chatId',
        component: lazy(() =>
          import('src/views/management/Chats/ChatBoxView')
        )
      },
      {
        exact: true,
        path: '/app/management/invoice/add-invoice',
        component: lazy(() =>
          import('src/views/management/Invoices/InvoiceCreateView')
        )
      },
      {
        exact: true,
        path: '/app/management/FAQs',
        component: lazy(() =>
          import('src/views/management/FAQ/FAQListView')
        )
      },
      {
        exact: true,
        path: '/app/management/FAQ/add-question',
        component: lazy(() =>
          import('src/views/management/FAQ/FAQCreateView')
        )
      },
    ]
  },
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
